import '../scss/section-parution-detail.scss';

const gallery = document.getElementById('gallery');
if (!gallery) return;
// console.log(gallery);
const viewer = new Viewer(gallery, {
  focus: false,
  fullscreen: false,
  title: false,
  rotatable: false,
  // Custom toolbar.
  toolbar: {
    zoomIn: {
      show: true,
      size: 'large',
    },
    zoomOut: {
      show: true,
      size: 'large',
    },
    oneToOne: {
      show: true,
      size: 'large',
    },
    prev: {
      show: true,
      size: 'large',
    },
    next: {
      show: true,
      size: 'large',
    },
  },
});
